<div class="step-header">
  <htx-badge [text]="badge()" variant="primary"></htx-badge>
  <h1 class="step-title">{{ title() }}</h1>
  @for (desc of descriptions(); track desc) {
    <p class="step-description">{{ desc }}</p>
  }
</div>
